// 번역 문구 confirm
export const CONFIRM = "confirm";
export const CANCEL = "cancel";

export const dialogMessage = {
  // en: {
  confirm: CONFIRM,
  cancel: CANCEL,

  loginFailed: {
    // 전화번호 로그인 - 전화번호 입력 인풋에 입력값이 없을 경우
    phoneNumberLoginPhoneNumberInputEmpty: {
      title: "login_fail",
      message: "phone_number_enter",
    },

    // 전화번호 로그인 - 비밀번호 입력 인풋에 입력값이 없을 경우
    phoneNumberLoginPasswordInputEmpty: {
      title: "login_fail",
      message: "password_hint_incomplete",
    },

    // 전화번호 로그인 - 등록이 안된 계정이거나 비밀번호가 틀린 경우
    phoneNumberLoginUnregisteredAccountOrWrongPassword: {
      title: "login_fail",
      message: "login_fail_phone_account",
    },

    // 등록되지 않은 전화번호이거나 비밀번호가 다릅니다.
    unregisteredPhoneNumberOrWrongPassword: {
      title: "login_fail",
      message: "login_fail_phone_account",
    },

    // 이메일 로그인 - 이메일 입력 인풋에 입력값이 없을 경우
    emailLoginEmailInputEmpty: {
      title: "login_fail",
      message: "email_hint_incomplete",
    },

    // 이메일 로그인 - 비밀번호 입력 인풋에 입력값이 없을 경우
    emailLoginPasswordInputEmpty: {
      title: "login_fail",
      message: "email_password_hint_incomplete",
    },

    // Firebase Auth에 미등록 됐거나 등록한 아이디 또는 비밀번호가 다를 경우
    firebaseAuthUnregisteredOrWrongCredentials: {
      title: "login_fail",
      message: "login_fail_not_register",
    },
    // 등록되지 않은 아이디거나 비밀번호가 다릅니다.(전화번호 / 소셜 로그인 / 이메일)
    unregisteredIdOrWrongPassword: {
      title: "login_fail",
      message: "login_fail_not_register",
    },

    // 소셜 로그인 시 해당 계정에 에러가 발생한 경우
    socialLoginAccountError: {
      title: "login_fail",
      message: "login_fail_social_account",
    },
    // 소셜 계정에 문제가 발생하여 로그인을 할 수 없습니다. 다시 시도해주세요.
    socialAccountLoginErrorPleaseRetry: {
      title: "login_fail",
      message: "login_fail_social_account",
    },

    // 일정 횟수 이상 시도하여 로그인이 불가능할 때
    loginAttemptsExceededTryLater: {
      title: "login_fail",
      message: "deregister_fail_try_again",
    },

    // 이미 탈퇴한 사용자일 때
    alreadyWithdrawnUser: {
      title: "login_fail",
      message: "login_fail_phone_account",
    },

    // 이 외 알 수 없는 에러로 실패할 경우
    unknownError: {
      title: "login_fail",
      message: "deregister_fail_try_again",
    },
  },

  // !: 로그아웃 실패
  // 로그아웃 프로세스에서 문제가 생겼을 경우
  logoutFailed: {
    title: "logout_fail",
    message: "logout_fail_retry",
  },

  // !: 비밀번호 재입력
  // 전화번호 로그인 유저가 재인증시 입력한 비밀번호가 틀린 경우
  reAuthenticationPassword: {
    title: "confirm_fail_password",
    message: "confirm_fail_incorrect_password",
  },

  // !: 회원 탈퇴 요청
  withdrawalRequest: {
    title: "account_delete", // "회원 탈퇴",
    message: "account_delete_irretrievable", // "탈퇴하면 그동안 골프픽스로 진단받은 모든 데이터가 삭제되어 복구할 수 없어요. 그래도 탈퇴하시겠어요?",
    buttons: [
      {
        confirm: "account_delete", // "회원 탈퇴",
      },
    ],
  },

  // !: 회원 탈퇴 실패
  // google 탈퇴 시 재인증한 토큰이 null 일 경우.. 많은 케이스들이 있으나 백엔드 API 구현에 따라 404, 500만 존재한다.
  withdrawalFailed: {
    404: {
      title: "deregister_fail",
      message: "deregister_fail_social_account",
    },
    500: {
      title: "deregister_fail",
      message: "deregister_fail_delete_fail",
      buttons: [
        {
          text: "contact",
        },
      ],
    },
  },

  // !: 회원 탈퇴 성공
  withdrawalSuccess: {
    title: "account_delete",
    message: "account_delete_success",
    buttons: [
      {
        text: CONFIRM,
      },
    ],
  },
};
